import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`

*{
  margin: 0;
  padding: 0;
  font-family: 'Ubuntu', sans-serif;
}
body {
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.white};
}
`
